import { inject, Injectable } from '@angular/core';
import { EMatchingType } from '@enums/campaign-analytics.enum';
import { EPlatformFeature } from '@enums/campaign.enum';
import { TSocialContent } from '@interfaces/campaign-analytics-api.interface';
import { IAnalyticsNode, ICampaignSocialContent } from '@interfaces/campaign-analytics.interface';
import { ICreator } from '@pages/creators/creators.interface';
import { CampaignAnalyticsUtilitiesService } from '@utilities/campaign-analytics-utilities.service';
import { SocialUtilitiesService } from '@utilities/social-utilities.service';
import { camelCase } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class CreatorDetailsSocialTilesService {
  private readonly campaignAnalyticsUtilitiesService = inject(CampaignAnalyticsUtilitiesService);

  public createAnalyticsNodes(socialContents: TSocialContent[] | null, creator: ICreator | null): IAnalyticsNode[] {
    if (!socialContents || !creator) {
      return [];
    }

    const analyticsNodes: IAnalyticsNode[] = [];
    const dummyProcessableAndCtaKpiStatusable =
      this.campaignAnalyticsUtilitiesService.getProcessableAndCtaKpiStatusable();

    socialContents.forEach((socialContent) => {
      const analyticsNode: IAnalyticsNode = {
        ...dummyProcessableAndCtaKpiStatusable,
        campaignId: '',
        content: {
          ...dummyProcessableAndCtaKpiStatusable,
          ctas: new Map(),
          id: uuidv4(),
          matchingType: EMatchingType.matched,
          socialContent,
        } as ICampaignSocialContent,
        creator,
        creatorId: creator.id,
        ctaIds: new Set(),
        emptyCtaAnalytics: null,
        executionStatus: EMatchingType.matched,
        executionTime: socialContent.executionTime,
        id: uuidv4(),
        isLive: SocialUtilitiesService.isSocialLive(socialContent),
        isReal: true,
        mergedCtaResult: dummyProcessableAndCtaKpiStatusable,
        nonExecutedCtaId: null,
        nonExecutedCtaName: null,
        plannedExecution: null,
        platformFeature: camelCase(socialContent.platformFeature) as EPlatformFeature,
      };

      analyticsNodes.push(analyticsNode);
    });

    return analyticsNodes;
  }
}
